import React from 'react';
import { node } from 'prop-types';
import { Box, Typography } from '@mui/material';

const ErrorCaption = ({ children = null }) => {
  if (!children) return null;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center', mr: '5px' }}>
      <Typography variant="caption" color="error">
        {children}
      </Typography>
    </Box>
  );
};

ErrorCaption.propTypes = {
  children: node,
};

export default ErrorCaption;
